import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WorkflowSteps } from 'src/app/create/models/workflowSteps.model';
// import { format } from 'date-fns';
// import { toZonedTime } from 'date-fns-tz';

export class IncidentLog {
  incidentLogId: number;
  incidentLogTitle: string;
  incidentLogDescription: string;
  surveyResponseId: number;
  workflowStepId: number;
  dayoftheWeek: string;
  workflowStep: WorkflowSteps;
  createUserId: string;
  createDate: string;
  updateUserId: string;
  updateDate: string;
}


@Component({
  selector: 'app-incident-history-dialog',
  templateUrl: './incident-history-dialog.component.html',
  styleUrl: './incident-history-dialog.component.scss'
,  standalone: false
})

export class IncidentHistoryDialogComponent implements OnInit {


  logs: IncidentLog[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.logs = this.data.logdata;
    this.logs = this.logs.sort((a, b) => {
      return new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime();
    });
    this.logs = this.logs.map(item => ({
      ...item,
      formattedDate: this.dateConversion(item.updateDate)
    }));
  }

  dateConversion(date:string):string{
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const dateObj = new Date(date);
    return dateObj.toLocaleString("en-US",{ timeZone: timeZone,year:"numeric",month:"long", hour: "numeric", minute: "numeric",timeZoneName:'short',day:'2-digit',hour12:true })
  }
  // Below method to convert UTC time to machine local time
  // formatLocalDate(dateString: string): string {
  //   if (!dateString) return '';

  //   const date = new Date(dateString);
  //   const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //   const zonedDate = toZonedTime(date, timeZone);

  //   return format(zonedDate, 'EEEE, MMMM d, yyyy h:mm a');
  // }
}


